import {JsonObject, JsonProperty, JsonSerializer, throwError} from "typescript-json-serializer";
import {dateToEsri, esriToDate} from "../utils/date-utils";

/**
 * Abstract model class
 */
@JsonObject()
export abstract class AbstractModel {

    protected static readonly comparableAttributes: string[];
    // workaround, because feature template doesn't seem to work for table features
    protected static readonly prototypeAttributes: string[];
    // field mappings
    protected static readonly databaseFieldNames: Map<string, string>;

    abstract class: string;

    @JsonProperty({name: "OBJECTID"})
        objectId: number;

    /**
     * Erstellt von
     */
    @JsonProperty({name: "CREATED_USER"})
        creator: string;

    /**
     * Erstellt am
     */
    @JsonProperty({
        name: "CREATED_AT",
        beforeDeserialize: esriToDate,
        afterSerialize: dateToEsri
    })
        createdAt: Date;

    /**
     * Geändert von
     */
    @JsonProperty({name: "UPDATED_USER"})
        editor: string;

    /**
     * Geändert am
     */
    @JsonProperty({
        name: "UPDATED_AT",
        beforeDeserialize: esriToDate,
        afterSerialize: dateToEsri
    })
        updatedAt: Date;

    /**
     * Feature
     */
    feature: __esri.Graphic;

    protected constructor() {
        // do not use makeObservable here. Not supported for derived classes
        // use makeObservable in constructor in each derived class
        // make sure you include all properties and functions of this abstract base class!
        // !! add observable, action, computed in derived classes when new functionality is added to this class !!
    }

    /**
     * Returns if it is a new record or if it is loaded from database
     */
    get isNewRecord(): boolean {
        return !this.objectId;
    }

    /**
     * The label displayed for items of this model.
     * e.g. for Options in dropdowns
     */
    abstract get displayLabel(): string;

    abstract get comparableAttributes(): string[];

    /**
     * If priority properties are allowed to change.
     * Depends on current process status.
     */
    abstract get isAlterable(): boolean;

    /**
     * Convert to JSON
     */
    toJSON(): object | object[] | null | undefined {
        const serializer = new JsonSerializer({
            errorCallback: throwError
        });
        return serializer.serializeObject(this);
    }

}

